import { Box, Typography } from '@mui/material';

import { formatEvvCaptureMethod, formatEvvDate, getEvvFallbackReasonLabel } from '../utils';

import type { EvvSideSummaryProps } from '../types';

export function EvvSideSummary({ label, side }: EvvSideSummaryProps) {
  return (
    <Box sx={{ flex: 1, minWidth: 240 }}>
      <Typography fontWeight={600}>{label}</Typography>
      <Typography variant="body2">Captured: {side.captured ? 'Yes' : 'No'}</Typography>
      <Typography variant="body2">Method: {formatEvvCaptureMethod(side)}</Typography>
      {side.captured && side.fallback_reason && (
        <Typography variant="body2">
          Reason: {getEvvFallbackReasonLabel(side.fallback_reason)}
        </Typography>
      )}
      <Typography variant="body2">Time: {formatEvvDate(side.captured_at)}</Typography>
      <Typography variant="body2">Latitude: {side.lat ?? '—'}</Typography>
      <Typography variant="body2">Longitude: {side.long ?? '—'}</Typography>
      <Typography variant="body2">Accuracy: {side.accuracy_meters ?? '—'} meters</Typography>
      <Typography variant="body2">Token status: {side.token_status ?? 'No token'}</Typography>
      <Typography variant="body2">Token expires: {formatEvvDate(side.token_expires_at)}</Typography>
    </Box>
  );
}
